import { render, staticRenderFns } from "./AiAlertCard.vue?vue&type=template&id=24bec540&scoped=true"
import script from "./AiAlertCard.vue?vue&type=script&lang=js"
export * from "./AiAlertCard.vue?vue&type=script&lang=js"
import style0 from "./AiAlertCard.vue?vue&type=style&index=0&id=24bec540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bec540",
  null
  
)

export default component.exports